export default __webpack_public_path__ + "91203a005706b6b0cd3686cbd9e7fe9f.svg";